import React, { useEffect } from "react";
import { BrowserRouter, Link, Route, useNavigate } from "react-router-dom";
import Container from "../components/Container";
import useNavigateToSection from "../hooks/useNavigateToSection";

const Work3: React.FC = () => {
  window.scrollTo(0, 0);
  const navigateToSection = useNavigateToSection();
  return (
    <main className="content pt-40">
      <Container>
        <article className="article mx-auto">
          <div className="article-container">
            <h2 className="article-title text-center text-3xl font-bold mb-4">
              Color Picker
            </h2>
            <div className="article-body grid gap-y-5">
              <div className="flex justify-center">
                <img
                  src="/color-generator.png"
                  alt=""
                  className="mb-4 max-h-[50rem] object-contain"
                />
              </div>
              <p className="mt-3">
                This is a website that suggests colors that harmonize well with
                the color you specify. You can choose from different types of
                color schemes such as monochrome, analogic, and complement. I
                created using HTML, CSS, JavaScript, and API.
              </p>
              <ul className="flex gap-x-3 flex-wrap gap-y-2">
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  HTML
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  CSS
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  Javascript
                </li>
                <li className="bg-3 h-color-2 rounded-full px-2 py-1 font-semibold">
                  API
                </li>
              </ul>
              <div>
                <h3 className="font-bold mb-2 text-xl">URL</h3>
                <p className="mb-4">
                  <a
                    href="https://tubular-platypus-2052ad.netlify.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://tubular-platypus-2052ad.netlify.app/
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">Github Repo</h3>
                <p className="mb-4">
                  <a
                    href="https://github.com/Mizuki-Kawabe/color-picker"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:text-blue-800 visited:text-purple-600"
                  >
                    https://github.com/Mizuki-Kawabe/color-picker
                  </a>
                </p>
              </div>
              <div>
                <h3 className="font-bold mb-2 text-xl">My role</h3>
                <p className="mb-4">Coding</p>
              </div>
            </div>

            <button
              className="font-bold block mx-auto my-10 h-color"
              onClick={() => navigateToSection("works")}
            >
              ← Go back to Works
            </button>
          </div>
        </article>
      </Container>
    </main>
  );
};

export default Work3;
